<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>配送一覧</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="送付先"
          dense
          v-model="params.search"
          @change="getShippings"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="ステータス"
          dense
          :items="$store.getters.shippingStatus"
          item-text="name"
          item-value="id"
          v-model="params.status"
          @change="getShippings"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="発送方法"
          dense
          :items="$store.getters.shippingMethods"
          item-text="name"
          item-value="id"
          v-model="params.shippingmethod"
          @change="getShippings"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="発送日（FROM）"
              readonly
              dense
              v-on="on"
              v-model="params.delivery_date__gte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.delivery_date__gte"
            @change="getShippings"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="発送日（TO）"
              dense
              readonly
              v-on="on"
              v-model="params.delivery_date__lte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.delivery_date__lte"
            @change="getShippings"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-select
          label="配送製品カテゴリ"
          :items=$store.getters.deliveryItemCategories
          item-text="name"
          item-value="id"
          dense
          v-model="params.deliveryitemdetail__deliveryitem__deliveryitemcategory"
          @change="getShippings"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="配送製品"
          :items="search_deliveryitems"
          item-text="name"
          item-value="id"
          dense
          v-model="params.deliveryitemdetail__deliveryitem"
          @change="getShippings"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="配送製品明細"
          dense
          :items="search_deliveryitemdetails"
          item-text="name"
          item-value="id"
          v-model="params.deliveryitemdetail"
          @change="getShippings"
        >
        </v-select>
      </v-col>
      <v-col
        cols="3"
      >
        <v-switch
          label="削除データも表示"
          v-model="contain_deleted"
          dense
          @change="getShippings"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="download"
        >
          対象一括ダウンロード
        </v-btn>
      </v-col>
      <v-col
        cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="data_download"
        >
          データダウンロード
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getShippings"
        >
        <template v-slot:item.change="{ item }">
          <v-switch v-model="item.status" class="ma-2"></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditDelivery', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="$router.push({ name: 'EditSubscription', params: {id: item.subscription.id}})"
              >
                <v-list-item-title
                >購読情報へ</v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
                v-if="!item.is_deleted"
              >
                <v-list-item-title
                >削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="配送データ削除"
          message="配送データを削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteShipping"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      headers: [
        {text: "顧客名称", value: "name_combined"},
        {text: "商品", value: "deliveryitemdetail.name"},
        {text: "個数", value: "amount"},
        {text: "送付先名称", value: "address_combined"},
        {text: "電話番号", value: "tel"},
        {text: "発送予定日", value: "delivery_date"},
        {text: "発行回数", value: "publish_count"},
        {text: "操作", value: "action", width: "130px"},
      ],
      items: [],
      params: {
        search: '',
        status: '',
        shippingmethod: '',
        delivery_date__lte: '',
        delivery_date__gte: '',
        deliveryitemdetail__deliveryitem__deliveryitemcategory: '',
        deliveryitemdetail__deliveryitem: '',
        deliveryitemdetail: '',
        search_deliveryitems: [],
        search_deliveryitemdetals: [],
        is_deleted: false,
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      search_deliveryitems: [],
      search_deliveryitemdetails: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      deleteItem: {},
      contain_deleted: false,
    }
  },
  watch: {
    'params.deliveryitemdetail__deliveryitem__deliveryitemcategory': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/`,
            {
              params: {'deliveryitemcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_deliveryitems = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_deliveryitems = []
      }
    },
    'params.deliveryitemdetail__deliveryitem': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_deliveryitemdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_deliveryitemdetails = [];
      }
    },
    contain_deleted: function() {
      if (this.contain_deleted) {
        this.params.is_deleted = null;
      } else {
        this.params.is_deleted = false;
      }
    }
  },
  methods: {
    async getShippings() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippings/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteShipping() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippings/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getShippings();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    },
    async download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippings/pdf_list/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "shipping_list.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
    async data_download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippings/list_download/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "shipping_list.xlsx");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>